"use strict";

(function (Drupal) {
  Drupal.behaviors.buttons = {
    attach: function attach(context, settings) {
      var buttons = context.querySelectorAll('a[class*="btn"], a[class*="link-button"]');
      buttons.forEach(function (button) {
        // Anchor tag title attributes are needed for hover effects on buttons.
        button.setAttribute('title', button.textContent);
      });
      var transparentButtons = context.querySelectorAll('.transparent-buttons a[class*="btn"],' + '.transparent-buttons a[class*="link-button"],' + '.transparent-buttons a[class="promo-right-margin"]');
      transparentButtons.forEach(function (button) {
        // Anchor tag title attributes are needed for hover effects on buttons.
        button.classList.add('btn--ghost');
      });

      // Every button that needs special styling will have a class of `.btn--ghost`.
      // We ensure this happens in CKEditor and anywhere else in the theme.
      // Query after the class is added above to ensure inclusion.
      var ghostButtons = context.querySelectorAll('.btn--ghost');
      ghostButtons.forEach(function (button) {
        // The ghost buttons have a border redraw animation, so we prepend
        // the markup that allows for this animation, but only when the button
        // has been specified as a ghosted button.
        button.insertAdjacentHTML('afterbegin', "<div class=\"btn--borders\">\n             <span class=\"btn--border-top\"></span>\n             <span class=\"btn--border-right\"></span>\n             <span class=\"btn--border-bottom\"></span>\n             <span class=\"btn--border-left\"></span>\n           </div>");
      });
    }
  };
})(Drupal);